import { render, staticRenderFns } from "./CancelBtn.vue?vue&type=template&id=d773a5ce&"
import script from "./CancelBtn.vue?vue&type=script&lang=js&"
export * from "./CancelBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports